export function setLocalStorage(key, value) {
    if (!key) { return }
    window.sessionStorage.setItem(key, value)
}

export function getLocalStorage(key) {
    if (!key) { return }
    return window.sessionStorage.getItem(key)
}